import React from "react";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Route, Switch } from "react-router-dom";
import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Training from "./components/Training";
import Farm from "./components/Farm";
import Technical from "./components/Technical";
import Advisory from "./components/Advisory";
// import Obasanjo from "./components/Obasanjo";
import Steve from "./components/Steve";
import Adebayo from "./components/AdvisoryCouncil/Adebayo";
import Iyadunni from "./components/AdvisoryCouncil/Iyadunni";
import Oluseun from "./components/AdvisoryCouncil/Oluseun";
import ProfYemi from "./components/AdvisoryCouncil/ProfYemi";
import Edna from "./components/AdvisoryCouncil/Edna";
import Contact from "./components/Contact";
import Blog from "./components/Blog";
import FirstPressRelease from "./components/Blog/components/FirstPressRelease";
import SecondPressRelease from "./components/Blog/components/SecondPressRelease";
import ThirdPressRelease from "./components/Blog/components/ThirdPressRelease";
import FourthPressRelease from "./components/Blog/components/FourthPressRelease";
import FifthPressRelease from "./components/Blog/components/FifthPressRelease";
import Projects from "./components/Projects";
import Consulting from "./components/Consulting/Consulting";
import SixthPublication from "./components/Blog/components/SixthPublication";
import SeventhPublication from "./components/Blog/components/SeventhPublication";
import EighthPublication from "./components/Blog/components/EighthPublication";
import NinethPublication from "./components/Blog/components/NinethPublication";
import TenthPublication from "./components/Blog/components/TenthPublication";

const theme = createTheme({
  typography: {
    fontFamily: {
      fontFamily: "Roboto",
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <div className="App">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/about-us" component={About} />
            <Route exact path="/contact-us" component={Contact} />
            <Route exact path="/our-projects" component={Projects} />
            <Route exact path="/blog" component={Blog} />
            <Route exact path="/advisory-council" component={Advisory} />
            {/* <Route
              exact
              path="/advisory-council/olusegun-obasanjo"
              component={Obasanjo}
            /> */}
            <Route
              exact
              path="/advisory-council/steve-okeleji"
              component={Steve}
            />
            <Route
              exact
              path="/advisory-council/tope-adebayo"
              component={Adebayo}
            />
            <Route
              exact
              path="/advisory-council/iyadunni-olubode"
              component={Iyadunni}
            />
            <Route
              exact
              path="/advisory-council/oluseun-onigbinde"
              component={Oluseun}
            />
            <Route
              exact
              path="/advisory-council/prof-yemi-akegbejo-samsoms"
              component={ProfYemi}
            />
            <Route
              exact
              path="/advisory-council/edna-eligado-dianisio"
              component={Edna}
            />
            <Route exact path="/our-services" component={Services} />
            <Route
              exact
              path="/our-services/ahan-consulting"
              component={Consulting}
            />
            <Route
              exact
              path="/our-services/training-institute"
              component={Training}
            />
            <Route exact path="/our-services/farm-services" component={Farm} />
            <Route
              exact
              path="/our-services/technical-department"
              component={Technical}
            />
            <Route
              exact
              path="/2024-07-29/boosting-Nigerias-economy-through-aquaculture-investment"
              component={TenthPublication}
            />
            <Route
              exact
              path="/2024-05-04/digital-innovations-in-fish-farming"
              component={NinethPublication}
            />
            <Route
              exact
              path="/2023-08-15/fishery-stock-assessments-and-sustainable-management-in-Nigeria"
              component={EighthPublication}
            />
            <Route
              exact
              path="/2022-11-22/climate-change-impacts-on-Nigerian-Aquaculture"
              component={SeventhPublication}
            />
            <Route
              exact
              path="/2022-02-10/sustainable-fish-farming-practices-in-Nigeria"
              component={SixthPublication}
            />
            <Route
              exact
              path="/2020-04-08/after-covid-19-what-next"
              component={FirstPressRelease}
            />
            <Route
              exact
              path="/2020-03-13/retirement-just-ahead"
              component={SecondPressRelease}
            />
            <Route
              exact
              path="/2019-04-04/fish-farming"
              component={ThirdPressRelease}
            />
            <Route
              exact
              path="/2019-03-19/aquaculture-the-ideal-industry"
              component={FourthPressRelease}
            />
            <Route
              exact
              path="/2019-03-04/aquahack-2019"
              component={FifthPressRelease}
            />
          </Switch>
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
